import { AfterViewInit, Component } from '@angular/core'
import { UserInfo } from '@corporate-tailwind/model'
import { AppSettingService, UserStore } from '@corporate-tailwind/store'
import { CorpPopMenuComponent } from '@corporate-tailwind/component'
import { LanguageSwitcherWidget, ThemeSwitcherWidget } from '@corporate-tailwind/widget';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'widget-user-menu',
    imports: [CorpPopMenuComponent, ThemeSwitcherWidget, LanguageSwitcherWidget],
    templateUrl: './user-menu.widget.html',
    styleUrl: './user-menu.widget.scss'
})
export class UserMenuWidget implements AfterViewInit {
    private readonly themeKey = 'trezo_theme';
    userInfo: UserInfo | null = null
    currentTheme: string | null = null;
    currentLanguage: string | null = null;

    constructor(
        private _userStore: UserStore,
        private _translateService: TranslateService,
        public _appSettingService: AppSettingService) {
    }

    ngOnInit(): void {
        this.userInfo = this._userStore.user();

        this.currentTheme = localStorage.getItem(this.themeKey); // === 'dark' ? 'light' : 'dark';

        this.currentLanguage = this._translateService.getCurrentLang() || this._translateService.getFallbackLang();
  
    }

    ngAfterViewInit() {

  // Le composant est rendu dans le DOM
}

    switchTheme() {
        this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    }

    // switchLanguage() {
    //     this.currentLanguage = this._translateService.getCurrentLang() || this._translateService.getFallbackLang();
    // }

}
